var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CircularProgress, Grid } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import RefreshIcon from "@mui/icons-material/Refresh";
import { filter } from "../utils/componentWizard";
import SubjectsDatePicker from "../utils/dateInputFilter";
import { SMALL_GRID_SPACE } from "../styles/styleConstants.data";
export var emptyBatchHistoryFilters = function () { return ({
    name: null,
    archive: null,
    createdFrom: null,
    createdTo: null,
    importStatus: null,
    reportStatus: null,
}); };
var STATUS_VALUES = [
    "UPLOADING",
    "UPLOADED",
    "QUEUED",
    "PENDING",
    "PROCESSING",
    "SUCCESS",
    "COMPLETED",
    "COMPLETED_WITH_ERRORS",
    "FAILED",
];
var filterActionButtonSx = {
    marginTop: "0.5em",
    height: "3.3em",
    width: "9em",
    fontWeight: "900",
    borderRadius: "20px",
    boxShadow: "0px 6px 8px gray",
    opacity: "0.6",
    transition: "all 0.3s ease-in-out",
    "&:hover": {
        transform: "scale(1.05)",
        boxShadow: "0px 8px 12px rgba(0, 0, 0, 0.3)",
        opacity: "1",
    },
    "&:active": {
        transform: "scale(0.95)",
    },
};
var BatchHistoryFilterList = function (_a) {
    var search = _a.search, onClear = _a.onClear, onRefresh = _a.onRefresh, isLoading = _a.isLoading, filters = _a.filters, setFilters = _a.setFilters, params = _a.params, translate = _a.translate;
    return (_jsxs(Grid, { container: true, spacing: SMALL_GRID_SPACE, justifyContent: "start", sx: { position: "sticky", top: 0, zIndex: 1000 }, children: [_jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: _jsx(filter.textField, { filters: filters, setFilters: setFilters, label: translate("pages.bulkGeneration.history.batchName"), name: "name", extraPath: "_history" }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: _jsx(filter.textField, { filters: filters, setFilters: setFilters, label: translate("pages.bulkGeneration.history.archive"), name: "archive", extraPath: "_history" }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: _jsx(SubjectsDatePicker, { filters: filters, setFilters: setFilters, label: translate("pages.bulkGeneration.history.createdFrom"), name: "createdFrom", minWidth: 180, minDate: new Date(2019, 8, 1), maxDate: new Date(), notNeedRequired: true }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: _jsx(SubjectsDatePicker, { filters: filters, setFilters: setFilters, label: translate("pages.bulkGeneration.history.createdTo"), name: "createdTo", minWidth: 180, minDate: new Date(2019, 8, 1), maxDate: new Date(), notNeedRequired: true }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: _jsx(filter.dropDownList, { filters: filters, setFilters: setFilters, label: translate("pages.bulkGeneration.history.importStatus"), name: "importStatus", minWidth: 160, options: params }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, children: _jsx(filter.dropDownList, { filters: filters, setFilters: setFilters, label: translate("pages.bulkGeneration.history.reportStatus"), name: "reportStatus", minWidth: 160, options: params }) }), _jsx(Grid, { item: true, xs: 12, sm: "auto", alignItems: "end", justifyContent: "flex-end", children: _jsxs(Grid, { container: true, spacing: 1, wrap: "nowrap", justifyContent: "flex-end", children: [_jsx(Grid, { item: true, children: _jsx(Button, { variant: "contained", disabled: isLoading, onClick: search, color: "common", startIcon: _jsx(SearchIcon, { sx: {
                                        animation: "pulse 2s infinite ease-in-out",
                                        "@keyframes pulse": {
                                            "0%": { transform: "scale(1)" },
                                            "50%": { transform: "scale(1.5)" },
                                            "100%": { transform: "scale(1)" },
                                        },
                                    } }), sx: __assign(__assign({}, filterActionButtonSx), { color: "#0d47a1", "&:hover": __assign(__assign({}, filterActionButtonSx["&:hover"]), { backgroundColor: "#1976d2", color: "white" }) }), children: isLoading ? _jsx(CircularProgress, { size: 24 }) : translate("common.search") }) }), _jsx(Grid, { item: true, children: _jsx(Button, { variant: "contained", disabled: isLoading, onClick: onClear, color: "common", startIcon: _jsx(ClearIcon, {}), sx: __assign(__assign({}, filterActionButtonSx), { color: "#0d47a1", "&:hover": __assign(__assign({}, filterActionButtonSx["&:hover"]), { backgroundColor: "#1976d2", color: "white" }) }), children: translate("common.clear") }) }), _jsx(Grid, { item: true, children: _jsx(Button, { variant: "contained", disabled: isLoading, onClick: onRefresh, color: "common", startIcon: _jsx(RefreshIcon, {}), sx: __assign(__assign({}, filterActionButtonSx), { color: "#0d47a1", "&:hover": __assign(__assign({}, filterActionButtonSx["&:hover"]), { backgroundColor: "#1976d2", color: "white" }) }), children: isLoading ? (_jsx(CircularProgress, { size: 24 })) : (translate("pages.bulkGeneration.actions.refresh")) }) })] }) })] }));
};
export var buildBatchHistoryFilterParams = function (translate) {
    var statusOptions = STATUS_VALUES.map(function (value) { return ({
        value: value,
        label: translate("pages.bulkGeneration.status.".concat(value)),
    }); });
    return {
        importStatus: statusOptions,
        reportStatus: statusOptions,
    };
};
export default BatchHistoryFilterList;
